export const ACCION_USUARIO = {
  prismic: 'Obtener contenido visual',
  maestros: 'Consultar maestros',
  config: 'Consultar información pago',
  pago: 'Pagar',
  estado: 'Consultar estado pago',
  redireccion: 'Pagar con pasarela (PSE - Botón Bancolombia)',
};
